import React, { useContext, useMemo } from 'react';
import { useIntl } from 'umi';
import TopChangeCard from '@/pages/dashboard/components/TopChangeCard';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import { formatTimeList, getMinute } from '../../_utils';
import { getLanguage } from '@home/utils/common';
import { LANGUAGE_EN } from '@home/_config/config';
import { dynamicString } from '@home/utils/dynamicString';

export default function AnalysisTopChangeCard(props: any) {
  const { config, data } = props;
  const { [config.apiKey]: apiData, hour, is_key_country: isKeyCountry, gameCode } = data;
  const { loading = true, errorMsg, data: componentData } = apiData;
  const { key: dataKey, table: tableKey, chart: chartKey, time: timeKey, downLoadCheckboxNameMap, downLoadTitleMap } = config.data;
  const error = errorMsg !== '';

  const { filterVal } = useContext(FilterContext);
  const { locale, formatMessage } = useIntl();
  const isEn = locale === LANGUAGE_EN;

  // 处理使用metricInfo中配置的文案
  const { time, title, title2, formatter, topTableFormatter, isPercent } = useMemo(() => {
    const time = {
      nowTime: filterVal?.singleDaily || '',
      preTime: filterVal?.contrastDaily || ''
    };
    const {
      title: titleEn,
      titleCn,
      formatTitle: configFormatTitle,
      title2: title2En,
      titleCn2,
      formatTitle2: configFormatTitle2,
      formatter: configFormatter,
      topTableFormatter,
      isPercent,
    } = config;
    // 标题
    const metricsTitle = getLanguage(isEn, dynamicString(titleEn, data), dynamicString(titleCn, data));
    const formatTitle = configFormatTitle ? formatMessage({ id: configFormatTitle }) : '';
    const title = titleEn || titleCn ? metricsTitle : formatTitle;
    // 表格和指标浮窗标题
    const metricsTitle2 = getLanguage(isEn, dynamicString(title2En, data), dynamicString(titleCn2, data));
    const formatTitle2 = configFormatTitle2 ? formatMessage({ id: configFormatTitle2 }) : '';
    const title2 = title2En || titleCn2 ? metricsTitle2 : formatTitle2;
    const formatter = dynamicString(configFormatter, data) || '';
    return { time, title, title2, formatter, topTableFormatter, isPercent };
  }, [filterVal, config, data, isEn]);

  const { cardTime, tableInfo, chartList } = useMemo(() => {
    const isChange = hour !== '23:59';
    const changeTime = getMinute(hour, 5);

    const cardTime = componentData?.[timeKey] || '';
    const chartList = isChange ? formatTimeList(componentData[chartKey], changeTime) || componentData[chartKey] : componentData?.[chartKey];
    const tableInfo = componentData?.[tableKey];
    return {
      cardTime,
      tableInfo,
      chartList
    };
  }, [data, hour]);

  return <>
    <TopChangeCard
      title={title}
      timeValue={hour}
      cardTime={cardTime}
      header2={title2}
      key2={dataKey}
      time={time}
      downLoadCheckboxNameMap={downLoadCheckboxNameMap}
      downLoadTitleMap={downLoadTitleMap}
      lastTime={cardTime}
      loading={loading}
      isError={error}
      tableData={tableInfo || []}
      dataList={chartList || []}
      isKeyCounTry={isKeyCountry}
      gameCode={gameCode}
      formatter={formatter}
      topTableFormatter={topTableFormatter}
      isPercent={isPercent}
    />
  </>;
}